var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootprint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "499.000000pt",
    viewBox: "0 0 500.000000 499.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,499.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2830 4198 c-21 -14 -47 -47 -65 -83 -26 -52 -30 -69 -30 -144 0 -74 4 -94 29 -144 89 -183 276 -91 280 138 1 91 -18 156 -63 206 -47 53 -99 62 -151 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3152 4105 c-42 -35 -64 -97 -64 -175 0 -111 54 -200 122 -200 37 0 88 43 111 95 23 51 25 161 3 213 -37 91 -110 119 -172 67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3441 3974 c-31 -26 -61 -101 -61 -153 0 -75 61 -171 108 -171 28 0 82 47 98 87 20 46 17 140 -5 189 -34 75 -87 93 -140 48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031 3872 c-22 -12 -46 -39 -65 -73 -29 -50 -31 -61 -31 -149 0 -84 3 -102 28 -152 88 -179 263 -104 275 117 7 124 -24 203 -97 252 -41 28 -66 29 -110 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3692 3800 c-44 -27 -72 -89 -72 -163 0 -52 3 -62 30 -89 25 -24 36 -29 58 -23 58 14 101 86 102 170 0 49 -28 115 -49 115 -5 0 -15 2 -23 5 -7 3 -28 -4 -46 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689 3769 c-105 -112 -50 -369 78 -369 75 0 130 102 121 223 -9 108 -60 177 -130 177 -32 0 -46 -6 -69 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2985 3684 c-69 -17 -128 -49 -174 -96 -73 -73 -96 -160 -88 -332 8 -194 60 -331 196 -513 75 -100 103 -163 122 -269 23 -132 -3 -269 -99 -515 -33 -85 -70 -192 -82 -239 -27 -102 -37 -256 -21 -328 36 -171 164 -286 334 -300 52 -4 66 -1 131 32 86 42 164 113 196 175 34 69 49 178 50 366 0 183 17 370 50 567 35 207 60 296 125 458 92 225 99 256 98 386 -2 209 -34 296 -149 403 -177 165 -479 256 -689 205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436 3649 c-79 -62 -85 -216 -11 -294 37 -40 70 -45 107 -15 84 65 75 270 -13 315 -38 20 -51 19 -83 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3844 3522 c-48 -31 -71 -153 -38 -200 30 -43 88 -22 123 45 16 32 14 115 -5 141 -15 22 -57 30 -80 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 3455 c-75 -95 22 -306 118 -255 46 25 63 119 34 188 -36 88 -110 120 -152 67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 3354 c-134 -28 -274 -91 -377 -168 -114 -86 -164 -174 -184 -321 -22 -172 -4 -280 83 -485 62 -144 86 -221 113 -363 45 -227 65 -420 71 -662 8 -325 25 -389 128 -483 112 -102 221 -132 337 -93 173 58 254 187 253 401 -1 132 -25 230 -109 445 -88 227 -100 275 -100 425 0 174 20 226 156 410 57 76 104 174 135 277 24 76 27 106 28 223 0 154 -16 214 -78 286 -87 102 -276 147 -456 108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054 3179 c-40 -45 -14 -176 41 -201 59 -27 102 23 93 107 -11 92 -87 146 -134 94z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprint);
export default __webpack_public_path__ + "static/media/footprint.d2d5b209fa7dd0f8a2657f086c1b7a87.svg";
export { ForwardRef as ReactComponent };